import React from "react";

const DeleteModal = ({ isOpen, onClose, onDelete }) => {
    if (!isOpen) return null;

    return (
        <div className="absolute h-full inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-hidden">
            <div className="bg-white p-4 rounded-lg shadow-lg w-[80%]">
                <h2 className="text-[18px] font-bold text-black mb-2">Delete Chat</h2>
                <p className="text-gray-600 mb-4 text-[14px]">
                    Are you sure you want to delete this chat? This action cannot be undone and all messages will be permanently removed.
                </p>
                <div className="flex justify-center gap-4">
                    <button
                        className="rounded-full bg-[#151515] hover:bg-[#272727] text-[12px] font-bold px-10 h-7 text-[#fff]"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="rounded-full text-[12px] px-10 h-7 bg-red-500 font-bold hover:bg-red-600 text-[#fff]"
                        onClick={onDelete}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;